/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from 'src/_metronic/helpers'
import {setLanguage, useLang} from 'src/app/modules/i18n/Metronici18n'

const LanguageList: FC = () => {
  const languages = [
    {
      lang: 'en',
      name: 'English',
      flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
    // {
    //   lang: 'zh',
    //   name: 'Mandarin',
    //   flag: toAbsoluteUrl('/media/flags/china.svg'),
    // },
    {
      lang: 'es',
      name: 'Spanish',
      flag: toAbsoluteUrl('/media/flags/spain.svg'),
      disabled: true,
    },
    // {
    //   lang: 'ja',
    //   name: 'Japanese',
    //   flag: toAbsoluteUrl('/media/flags/japan.svg'),
    // },
    // {
    //   lang: 'de',
    //   name: 'German',
    //   flag: toAbsoluteUrl('/media/flags/germany.svg'),
    // },
    // {
    //   lang: 'fr',
    //   name: 'French',
    //   flag: toAbsoluteUrl('/media/flags/france.svg'),
    // },
  ]

  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  const itemClass = 'ms-1 ms-lg-3'
  const langClass = 'symbol-35px'

  return (
    <div className=''>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol symbol-badge d-flex items-center', langClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-start'
        >
          <img
            data-kt-element='current-lang-flag'
            className='w-25px h-25px rounded-circle me-3'
            src={currentLanguage?.flag}
            alt=''
          />
          <span data-kt-element='current-lang-name' className='me-2'>
            {currentLanguage?.name}
          </span>
          <i className='ki-outline ki-down fs-2  m-0'></i>
        </div>
        <div
          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
          data-kt-menu='true'
        >
          {languages.map((l) => (
            <div
              className='menu-item px-3'
              key={l.lang}
              onClick={() => {
                if (l.disabled) return
                setLanguage(l.lang)
              }}
            >
              <a
                className={clsx('menu-link d-flex px-5', {
                  active: l.lang === currentLanguage?.lang,
                })}
                style={{
                  cursor: 'pointer',
                  pointerEvents: l.disabled ? 'none' : 'auto',
                  opacity: l.disabled ? 0.6 : 1,
                }}
              >
                <span className='symbol symbol-20px me-4'>
                  <img className='rounded-1' src={l.flag} alt={l.name} />
                </span>
                {l.name}
              </a>
            </div>
          ))}{' '}
        </div>
      </div>
    </div>
  )
}

export {LanguageList}
